import { Typography } from '@arionbanki/arionui';
import { Footer, ProgressBar, Questions } from 'components';
import { TEST_TYPE_INT } from 'consts';
import { useRiskq } from 'hooks/useRiskq';

export function Suitability() {
	const { group, page, title, t, ...ctx } = useRiskq(TEST_TYPE_INT.SUITABILITY);
	return (
		<ProgressBar page={page}>
			<Typography TagName="h3" className="mb-5">
				{title}
			</Typography>
			<Questions group={group} />
			<Footer {...ctx} />
		</ProgressBar>
	);
}
